/**
 * Single source of truth for the KONE Flow Design System color tokens used
 * across this plugin (View 1: BusinessApplicationsPage.tsx, View 2:
 * BusinessApplicationDetailsPage.tsx + everything under details/).
 *
 * Both pages inject their own <style> tag (Backstage has no first-class
 * theming hook wired up for this plugin yet), so this constant is meant to
 * be interpolated into each page's own `:root { ... }` block rather than
 * each page maintaining its own separate copy of the palette — the
 * previous version of this plugin had View 1 defining `--brand-*` and View
 * 2 defining `--kone-*` as two parallel token systems for the exact same
 * colors, which is exactly the kind of drift this file exists to prevent.
 *
 * Approved palette per the KONE Flow Design System color guidelines:
 *   - Primary: KONE Blue (#1450F5), White (#FFFFFF), Black (#141414)
 *   - Secondary (sparingly): Sand, Yellow, Light Blue, Pink, Green
 *   - Status: Success, Warning, Error
 *   - Approved Blue Scale: #1450F5 / #4373F7 / #7296F9 / #A1B9FB / #D0DCFD
 *   - Approved Neutral Scale: #141414 / #434343 / #727272 / #A1A1A1 / #D0D0D0
 *
 * No purple, no invented one-off shades (e.g. a custom-darkened blue for
 * gradients, or a custom-darkened success/warning/error for badge text) —
 * every color used anywhere in this plugin should trace back to one of
 * these tokens (or a plain rgba() tint of one, for a lighter badge/notice
 * background).
 */
export const KONE_ROOT_VARS = `
  --kone-blue: #1450F5;
  --kone-blue-light: #4373F7;
  --kone-white: #FFFFFF;
  --kone-black: #141414;
  --kone-sand: #F3EEE6;
  --kone-yellow: #FFE141;
  --kone-light-blue: #D2F5FF;
  --kone-pink: #FFCDD7;
  --kone-green: #AAE1C8;
  --kone-success: #1ED273;
  --kone-warning: #FFA023;
  --kone-error: #FF5F28;
  --kone-neutral-2: #434343;
  --kone-neutral-3: #727272;
  --kone-neutral-4: #A1A1A1;
  --kone-neutral-5: #D0D0D0;
  --kone-surface: #FFFFFF;
  --kone-surface-alt: #F8FAFC;
  --kone-border: #E7EBF0;
  --kone-text: #141414;
  --kone-text-muted: rgba(20, 20, 20, 0.72);
  --kone-radius: 12px;
  --kone-shadow: 0 8px 24px rgba(20, 80, 245, 0.08);
`;
